import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Item, renderKeyValue } from "./Common";
import EditImg from "../asserts/img/edit_doc.svg";
import ExpandOpen from "../asserts/img/expand_open.svg";
import ExpandClose from "../asserts/img/expand_close.svg";
import { format } from "date-fns";

const ReportDetailMobileRow = ({ report, keys, handelRowClick }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("month_reports");

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        flexDirection: "column",
        borderBottom: `1px solid #D9D9D9`,
        paddingBottom: 14,
      }}>
      <div
        style={{
          display: "flex",
          gap: 20,
          width: "100%",
          alignItems: "center",
          flex: 1,
          padding: "15px 20px 5px 15px",
        }}>
        <img
          src={open ? ExpandOpen : ExpandClose}
          alt="expand"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(!open);
          }}
        />
        <Item
          value={format(new Date(report.CURDATE), "dd/MM/yyyy")}
          width={"50%"}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginInlineStart: "auto",
          }}>
          <button
            onClick={(e) => {
              handelRowClick(e, report);
            }}
            style={{
              border: 0,
              backgroundColor: "white",
              cursor: "pointer",
            }}>
            <img alt="EditImg" src={EditImg} style={{ marginInlineEnd: 5 }} />
          </button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: 20,
          width: "100%",
          alignItems: "start",
          flex: 1,
          paddingInline: 20,
        }}></div>
      <div
        style={{
          display: "flex",
          padding: `0px 20px 10px`,
          alignSelf: "start",
          width: "100%",
        }}>
        <Item label={t("HOURS")} value={report.HOURS} width={"50%"} />
        <Item label={t("EXTRA")} value={report.EXTRA} width={"50%"} />
      </div>
      {open && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: 20,
            paddingTop: 0,
            paddingBottom: 10,
            width: "100%",
          }}>
          {keys.map((key) => (
            <Item
              label={t(key?.key)}
              value={renderKeyValue(key, report)}
              width={"50%"}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ReportDetailMobileRow;
